export const blogsData = [
  {
    blogName:
      "Unraveling JavaScript's Asynchronous Nature: Promises and the Event Loop Explained 🙌",
    blogDescription:
      "JavaScript is a single-threaded language, but we can introduce asynchronous behavior using Promises 💡🚀. While you may think that this concept is similar to using browser-native methods like setTimeout for asynchronous behavior, there are some key differences to be aware of 🤔 .",
    imageUrl:
      "https://png.pngtree.com/thumb_back/fh260/background/20210311/pngtree-green-branch-golden-linear-draft-watercolor-background-image_584000.jpg",
    blogUrl:
      "https://www.linkedin.com/posts/anupam-patra-921634ab_javascript-webdevelopment-frontenddevelopment-activity-7066681660984983553-eD78?utm_source=share&utm_medium=member_desktop",
  },
  {
    blogName: "What are some rare photos that can't be explained?😱",
    blogDescription:
      "I'll be showcasing intriguing, unexplained photos from both the past and the present, including modern-day mysteries that often go unnoticed. Mysteries persist even in today's world, with many remaining unexplained, challenging our understanding of the world.",
    imageUrl:
      "https://img.freepik.com/free-vector/leaves-wallpaper-with-metallic-foil-concept_79603-942.jpg?w=360",
    blogUrl: "https://qr.ae/pyfbzg",
  },
  {
    blogName:
      "Understanding Garbage Collection in V8: A Deep Dive into JavaScript Memory Management.💪",
    blogDescription:
      "Garbage Collection (GC) in JavaScript, particularly in the V8 engine, automates memory management, freeing developers from manual memory handling. V8’s GC system helps prevent memory leaks and performance issues, ensuring efficient application performance.",
    imageUrl:
      "https://images.unsplash.com/photo-1533119408463-b0f487583ff6?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bGVhZiUyMGJhY2tncm91bmR8ZW58MHx8MHx8fDA%3D",
    blogUrl: "https://shorturl.at/oQyYr",
  },
];
